import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const SupportSection = () => {
  return (
    <div>
      <Paragraph>
        Club Sports Solutions L.L.C. ("Provider") will provide reasonable
        technical support to assist Customer with the use of the TrackBiz
        platform during the term of this Agreement.
      </Paragraph>

      <Paragraph>
        <Text strong>Support may be provided through:</Text>
      </Paragraph>

      <ul>
        <li>Email support</li>
        <li>Phone support</li>
        <li>Remote assistance sessions</li>
        <li>General product guidance and troubleshooting</li>
      </ul>

      <Paragraph>
        Provider will use commercially reasonable efforts to respond to support
        requests in a timely manner, but does not guarantee specific response or
        resolution times.
      </Paragraph>

      <Alert
        message="Included Support"
        description="Standard subscription fees include reasonable technical support related to the use of TrackBiz and resolution of software-related issues."
        type="success"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Support is limited to issues directly related to TrackBiz and does not
        include services that fall outside the normal operation of the platform.
      </Paragraph>

      <Paragraph>
        <Text strong>Support does not include:</Text>
      </Paragraph>

      <ul>
        <li>Custom software development</li>
        <li>New feature development</li>
        <li>Business consulting services</li>
        <li>Data entry or administrative services</li>
        <li>Training services beyond reasonable onboarding assistance</li>
        <li>Third-party software troubleshooting not caused by TrackBiz</li>
      </ul>

      <Alert
        message="Additional Services"
        description="Custom development, special integrations, consulting services, and other work outside standard support may require a separate written agreement and additional fees."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Provider may periodically perform maintenance, upgrades, security
        updates, and improvements to TrackBiz. Reasonable efforts will be made
        to minimize service interruptions during such activities.
      </Paragraph>
    </div>
  );
};

export default SupportSection;